import { createActions, handleActions } from 'redux-actions';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  PUBNUB_SUBSCRIBE: 'PUBNUB_SUBSCRIBE',
  PUBNUB_SUBSCRIBE_SUCCESS: 'PUBNUB_SUBSCRIBE_SUCCESS',
  PUBNUB_SUBSCRIBE_FAILURE: 'PUBNUB_SUBSCRIBE_FAILURE',
  PUBNUB_UNSUBSCRIBE: 'PUBNUB_UNSUBSCRIBE',
  PUBNUB_UNSUBSCRIBE_SUCCESS: 'PUBNUB_UNSUBSCRIBE_SUCCESS',
  PUBNUB_UNSUBSCRIBE_FAILURE: 'PUBNUB_UNSUBSCRIBE_FAILURE',
  PUBNUB_RESUBSCRIBE: 'PUBNUB_RESUBSCRIBE',
  PUBNUB_RESUBSCRIBE_SUCCESS: 'PUBNUB_RESUBSCRIBE_SUCCESS',
  PUBNUB_RESUBSCRIBE_FAILURE: 'PUBNUB_RESUBSCRIBE_FAILURE',
};

export const {
  pubnubSubscribe,
  pubnubSubscribeSuccess,
  pubnubSubscribeFailure,
  pubnubUnsubscribe,
  pubnubUnsubscribeSuccess,
  pubnubUnsubscribeFailure,
  pubnubResubscribe,
  pubnubResubscribeSuccess,
  pubnubResubscribeFailure,
} = createActions(
  {
    [types.PUBNUB_SUBSCRIBE]: ({ channels, userId }) => ({
      channels,
      userId,
    }),
    [types.PUBNUB_SUBSCRIBE_FAILURE]: (errorMessage) => ({ errorMessage }),
    [types.PUBNUB_SUBSCRIBE_SUCCESS]: (channels) => ({ channels }),
    [types.PUBNUB_RESUBSCRIBE]: ({ channels, userId }) => ({
      channels,
      userId,
    }),
    [types.PUBNUB_RESUBSCRIBE_FAILURE]: (errorMessage) => ({ errorMessage }),
    [types.PUBNUB_UNSUBSCRIBE_FAILURE]: (errorMessage) => ({ errorMessage }),
  },
  types.PUBNUB_UNSUBSCRIBE,
  types.PUBNUB_UNSUBSCRIBE_SUCCESS,
  types.PUBNUB_RESUBSCRIBE_SUCCESS
);

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  errorMessage: '',
  subscribedChannels: [],
};

const reducer = handleActions(
  {
    [types.PUBNUB_SUBSCRIBE]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
      subscribedChannels: [],
    }),
    [types.PUBNUB_SUBSCRIBE_SUCCESS]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.READY,
      subscribedChannels: action.payload.channels,
      errorMessage: '',
    }),
    [types.PUBNUB_SUBSCRIBE_FAILURE]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      subscribedChannels: [],
      errorMessage: action.payload.errorMessage,
    }),
    [types.PUBNUB_UNSUBSCRIBE]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.PUBNUB_UNSUBSCRIBE_SUCCESS]: (state) => ({
      ...state,
      loadingStatus: loadingState.READY,
      subscribedChannels: [],
      errorMessage: '',
    }),
    [types.PUBNUB_UNSUBSCRIBE_FAILURE]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.PUBNUB_RESUBSCRIBE]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.PUBNUB_RESUBSCRIBE_SUCCESS]: (state) => ({
      ...state,
      loadingStatus: loadingState.READY,
      errorMessage: '',
    }),
    [types.PUBNUB_RESUBSCRIBE_FAILURE]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
  },
  INIT_STATE
);

export default reducer;



// WEBPACK FOOTER //
// ./src/services/redux/pubnubQuestionList.js